import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ProductAttribute } from 'src/app/assabil-kernel/models/entities/control-tables/product-attribute';


@Component({
  selector: 'app-product-attribute-list',
  templateUrl: './product-attribute-list.component.html',
  styleUrls: ['./product-attribute-list.component.scss']
})
export class ProductAttributeListComponent extends BasePage2< ProductAttribute> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productAttributes: ProductAttribute[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      //protected vatService        : VatService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName  = 'productAttribute';
  }


  listFields = [
      { prop: 'visitResultCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'theValue', name: 'Valeur' },

  ]

  getRows(): ProductAttribute[] {
      return this.productAttributes;
  }

  saveRow(row: ProductAttribute): Promise<ProductAttribute> {
      return null;
  }

  loadData() {
  //     this.vatService.vatsGet(this.code, this.name).then(result => {
  //         this.partnersAnalysisGroups = result;
  //         
  //     }).catch(error => {
  //         this.showError(error);
  //     })
  // }

  }
}
